import { formatDate, switchACMG } from '@/@core/utils/utils'

export const getTemplate1 = (
  report: any,
  reportValue: any,
  reportsVariants: any[],
  reportsVariantsType: any,
  t: any
) => {
  const reportsVariantsAcmg = reportsVariants
    .map(
      (item) =>
        item.user_acmg_classification ??
        item.ACMG_classification ??
        item.acmg_classification ??
        item.classification
    )
    .join('/')
  const terms =
    reportValue.sample?.terms && JSON.parse(reportValue.sample?.terms)
      ? JSON.parse(reportValue.sample?.terms)
      : []

  return [
    {
      type: 'block-title',
      children: [
        {
          text: '/images/logos/genomelight_logo.png'
        }
      ]
    },
    {
      type: 'header2',
      children: [
        {
          text: 'LABORATORY REPORT'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-eh',
              children: [
                {
                  type: 'header4',
                  children: [{ text: 'Patient Information' }]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Patient no.：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `${reportValue.sample?.id ?? '-'}`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Patient Name：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `${reportValue.patient?.patientName ?? '-'}`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Date of Birth：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `${reportValue.patient?.dateOfBirth ?? '-'}`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Gender：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `${
                                (reportValue?.patient?.gender as string) ?? '-'
                              }`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Ethnicity：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `${t(
                                (reportValue.patient?.ethnicity as string) ??
                                  '-'
                              )}`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-eh',
              children: [
                {
                  type: 'header4',
                  children: [{ text: 'Laboratory' }]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Physician Name：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `${
                                reportValue.patient?.physicianName ?? '-'
                              }`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Specimen：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `${reportValue?.sample?.vcfType?.toLocaleUpperCase()}`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Received Date：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `${
                                formatDate(reportValue.patient?.arrivalDate) ??
                                '-'
                              }`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Prepared by：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `-`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'p5-genetic-value',
                  children: [
                    {
                      type: 'paragraph-2',
                      children: [
                        {
                          type: 'span-blod',
                          children: [
                            {
                              text: `Report Date：`
                            }
                          ]
                        },
                        {
                          type: 'span',
                          children: [
                            {
                              text: `${formatDate(report?.createdAt) ?? '-'}`
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: 'TEST REQUESTED：'
        },
        {
          text: `${reportValue?.sample?.vcfType?.toLocaleUpperCase()}`
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'CLINICAL INFORMATION*：'
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: terms.map((i: any) => `${i.hpo_code}:(${i.name_en})`).join(';')
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'TEST RESULT：'
        }
      ]
    },
    {
      type: 'header-box',
      children: [
        {
          type: 'header4',
          children: [
            {
              text:
                report?.result === 'positive'
                  ? 'POSITIVE RESULT'
                  : 'NEGATIVE RESULT'
            }
          ]
        },
        {
          type: 'paragraph',
          children: [
            {
              text:
                report?.result === 'positive'
                  ? `${switchACMG(
                      reportsVariantsAcmg
                    )} gene variants were detected that could interpret clinical information`
                  : 'No pathogenic/suspected pathogenic gene variants were detected that could clearly interpret clinical information'
            }
          ]
        }
      ]
    },
    {
      type: 'header-box',
      children: [
        {
          type: 'header4',
          children: [
            {
              text: 'INTERPRETATION'
            }
          ]
        },
        ...reportsVariants.map((row) => {
          const acmg = row.user_acmg_classification
            ? row.user_acmg_classification
                ?.split(' ')
                .map((word: string) => {
                  if (word.includes('Uncertain')) return `VU`
                  if (word.includes('uncertain')) return `VU`
                  if (word.includes('null')) return ``
                  else return word[0].toUpperCase()
                })
                .join('')
            : row.ACMG_classification
            ? row.ACMG_classification?.split(' ')
                .map((word: string) => {
                  if (word.includes('Uncertain')) return `VU`
                  if (word.includes('uncertain')) return `VU`
                  if (word.includes('null')) return ``
                  else return word[0].toUpperCase()
                })
                .join('')
            : row.acmg_classification
            ? row.acmg_classification
                ?.split(' ')
                .map((word: string) => {
                  if (word.includes('Uncertain')) return `VU`
                  if (word.includes('uncertain')) return `VU`
                  if (word.includes('null')) return ``
                  else return word[0].toUpperCase()
                })
                .join('')
            : row.classification
            ? row.classification
                ?.split(' ')
                .map((word: string) => {
                  if (word.includes('Uncertain')) return `VU`
                  if (word.includes('uncertain')) return `VU`
                  if (word.includes('null')) return ``
                  else return word[0].toUpperCase()
                })
                .join('')
            : ''
          return {
            type: 'paragraph-noBreak',
            children: [
              {
                text: `By ${
                  reportValue.sample?.vcfType === 'wes'
                    ? 'Whole gene exome sequencing'
                    : reportValue.sample?.vcfType
                }, a heterozygous ${acmg} variant ${row.c_nomen} ( ${
                  row.p_nomen
                } ) in the ${row.gene} gene was identified.`
              }
            ]
          }
        })
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'RECOMMENDATIONS：'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: '1. Genetic counseling is recommended to discuss the implications of this test report and test results should be interpreted in the context of the patient’s medical evaluation, family history, and racial/ethnic background.'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: '2. Reinterpretation of exome sequencing data is recommended on an annual basis and may be requested by the referring clinician and one should be cautious about that variant classication and/or interpretation may change over time if more information becomes available and identication of new variants associated with disease phenotype during the re-assessment.'
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: "3. A clear genetic explanation for the disease in this individual could not be found as only VUS's were identied. Further studies (clinical/functional) may help in ascertaining the role (if any) of these variants in the disease predisposition."
        }
      ]
    },
    {
      type: 'paragraph-small',
      children: [
        {
          text: '4. Family segregation study is recommended to confirm the classification of variant(s) found here.'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'RESULT DETAILS:'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color',
              children: [{ text: 'GENE' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'CHANGES' }]
            },
            {
              type: 'table-cell-color',
              children: [
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'gAD_ALL'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'gAD_AFR'
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  children: [
                    {
                      text: 'gAD_AMR'
                    }
                  ]
                }
              ]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'ZYGOSITY' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'INHERITANCE' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'CLASSIFICATION' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'TYPE' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'OMIM' }]
            }
          ]
        },

        ...reportsVariants.map((row) => {
          return {
            type: 'table-row',
            children: [
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph-gene',
                    children: [
                      {
                        text: `${row.gene}`
                      }
                    ]
                  },
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.transcript ?? '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text:
                          row.chrom && row.pos
                            ? `${row.chrom}:${row.pos}:${
                                row.nuc_change ?? `${row.ref}>${row.alt}`
                              }`
                            : row.chrom && row.SV_start
                            ? `${row.chrom}:${row.SV_start}:${row.SV_end}`
                            : row.chrom && row.start
                            ? `${row.chrom}:${row.start}:${row.end}`
                            : ''
                      }
                    ]
                  },
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.c_nomen ?? '-'
                      }
                    ]
                  },
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.p_nomen ?? '-'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: `${
                          row.gnomAD_exome_ALL
                            ? row.gnomAD_exome_ALL
                            : row.gnomade_af
                            ? row.gnomade_af
                            : '-'
                        }`
                      }
                    ]
                  },
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: `${
                          row.gnomAD_exome_AFR
                            ? row.gnomAD_exome_AFR
                            : row.gnomade_afr_af
                            ? row.gnomade_afr_af
                            : '-'
                        }`
                      }
                    ]
                  },
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: `${
                          row.gnomAD_exome_AMR
                            ? row.gnomAD_exome_AMR
                            : row.gnomade_amr_af
                            ? row.gnomade_amr_af
                            : '-'
                        }`
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.coverage
                          ? row.coverage
                          : row.ad
                          ? row.ad
                          : '-'
                      }
                    ]
                  },
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.allele_frequency
                          ? row.allele_frequency < 0.85
                            ? 'heterozygote'
                            : 'homozygote'
                          : row.allele_balance
                          ? row.allele_balance < 0.85
                            ? 'heterozygote'
                            : 'homozygote'
                          : '无'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.inheritance
                          ? row.inheritance
                          : row.inheritances
                          ? row.inheritances.join(';')
                          : row.omim_info
                          ? row.omim_info
                              .map((i: any) => i.inheritance)
                              .join(';')
                          : row.OMIMData
                          ? row.OMIMData.map((i: any) => i.inheritance).join(
                              ';'
                            )
                          : ''
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.user_acmg_classification
                          ? row.user_acmg_classification
                              ?.split(' ')
                              .map((word: string) => {
                                if (word.includes('Uncertain')) return `VU`
                                if (word.includes('uncertain')) return `VU`
                                if (word.includes('null')) return ``
                                else return word[0].toUpperCase()
                              })
                              .join('')
                          : row.ACMG_classification
                          ? row.ACMG_classification?.split(' ')
                              .map((word: string) => {
                                if (word.includes('Uncertain')) return `VU`
                                if (word.includes('uncertain')) return `VU`
                                if (word.includes('null')) return ``
                                else return word[0].toUpperCase()
                              })
                              .join('')
                          : row.acmg_classification
                          ? row.acmg_classification
                              ?.split(' ')
                              .map((word: string) => {
                                if (word.includes('Uncertain')) return `VU`
                                if (word.includes('uncertain')) return `VU`
                                if (word.includes('null')) return ``
                                else return word[0].toUpperCase()
                              })
                              .join('')
                          : row.classification
                          ? row.classification
                              ?.split(' ')
                              .map((word: string) => {
                                if (word.includes('Uncertain')) return `VU`
                                if (word.includes('uncertain')) return `VU`
                                if (word.includes('null')) return ``
                                else return word[0].toUpperCase()
                              })
                              .join('')
                          : ''
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph',
                    children: [
                      {
                        text: row.variantsType
                      }
                    ]
                  }
                ]
              },
              {
                type: 'table-cell',
                children: [
                  {
                    type: 'paragraph-gene',
                    children: [
                      {
                        text: row.OMIMEN
                          ? row.OMIMEN
                          : row.omim_info
                          ? row.omim_info.map((i: any) => i.phenoName).join(';')
                          : ''
                      }
                    ]
                  },
                  {
                    type: 'paragraph-gene',
                    children: [
                      {
                        text: row.OMIM?.geneMim
                          ? `OMIM ID: ${row.OMIM?.geneMim}`
                          : ''
                      }
                    ]
                  }
                ]
              }
            ]
          }
        })
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'DETAILS ABOUT GENE AND VARIANTS：'
        }
      ]
    },
    ...[
      ...reportsVariants
        .filter((item) => item.Details)
        .map((item) => {
          return [
            {
              type: 'paragraph',
              children: [
                {
                  text: item.Details
                    ? `${item.gene}: ${item.Details?.geneInfo?.function}`
                    : ''
                }
              ]
            },
            {
              type: 'paragraph',
              children: [
                {
                  text: ''
                }
              ]
            },
            {
              type: 'paragraph',
              children: [
                {
                  text: item.Details
                    ? `The heterozygous pathogenic variant ${item.c_nomen} ( ${
                        item.p_nomen
                      } ) in ${
                        item.gene
                      } was identified. The highest population frequency of this
variant in Gnomad is ${item.gnomAD_genome_ALL}. This variant is ${
                        item.acmg_evidences?.length
                          ? item.acmg_evidences.join(';')
                          : ''
                      }.  This category is no longer in
general use.. Based on the evidence, This ${
                        item.var_location ?? item.variant_locations?.join(';')
                      }, ${
                        item.coding_effect ?? item.consequence
                      } variant is classified as ${
                        item.user_acmg_classification
                          ? item.user_acmg_classification
                          : item.ACMG_classification
                          ? item.ACMG_classification
                          : item.acmg_classification
                      } for ${reportValue.sample?.clinicalInformation}`
                    : ''
                }
              ]
            },
            {
              type: 'paragraph',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        })
        .flat()
    ],
    {
      type: 'header3',
      children: [
        {
          text: 'METHODS：'
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: 'RNA capture baits against approximately 60 Mb of the Human Exome (targeting >99% of regions in CCDS, RefSeq and Gencode databases) is used to enrich regions of interest from fragmented genomic DNA with Agilent’s SureSelect Human All Exon V8 kit. The generated library is sequenced on an Illumina platform to obtain an average coverage depth of ~50x. In this sample, around 25,000 genes have been sequenced, and XX.YY% of targets are covered with at least 10x. An end to end inhouse bioinformatics pipeline including base calling, alignment of reads to GRCh37/hg19 genome assembly, primary ltering out of low-quality reads and probable artefacts, and subsequent annotation of variants, is applied. Approximately, all diseasecausing variants reported in HGMD®, in ClinVar as well as all variants with minor allele frequency (MAF) of less than 1% in gnomAD database are considered. Evaluation is focused on coding exons along with anking +/-20 intronic bases. All pertinent inheritance patterns are considered. In addition, provided family history and clinical information are used to evaluate eventually identied variants. All identified small SNV/indels, mitochondrial variants and Copy Number Variants (CNVs) are evaluated with respect to their pathogenicity and causality, and these are categorized into classes pathogenic, likely pathogenic, variant of unknown significance (VUS), likely benign and benign. All potentially causative variants in genes related to the phenotype of the patient, except benign or likely benign variants, are reported. Variants of relevance identied by NGS are continuously and individually in-house validated for quality aspects; those variants which meet our internal QC criteria (based on extensive validation processes) are not validated by Sanger.'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'LIMITATIONS：'
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: 'Test results are interpreted in the context of clinical findings, family history and other laboratory data. Only variations in genes potentially related to the proband’s medical condition are reported. Rare polymorphisms may lead to false negative or positive results. Misinterpretation of results may occur if the information provided is inaccurate or incomplete. If results obtained do not match the clinical findings, additional testing should be considered. Specific genetic events like copy number variants, translocations and repeat expansions may not be reliably detected with Exome Sequencing. In addition, due to limitations in technology, certain regions may either not be covered or may be poorly covered, where variants cannot be confidently detected.'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'ADDITIONAL INFORMATION：'
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: 'This test was developed and its performance validated by Genomelight. The US Food and Drug Administration (FDA) has determined that clearance or approval of this method is not necessary and thus neither have been obtained. This test has been developed for clinical purposes. All test results are reviewed, interpreted and reported by our scientific and medical experts. In line with ACMG recommendations for reporting of incidental findings in clinical exome and genome sequencing (Genetics in Medicine, 2016), we report incidental findings, i.e. pathogenic variants (class 1) and likely pathogenic variants (class 2) only in the recommended genes for the recommended phenotypes. To also exclude mistaken identity in your clinic, several guidelines recommend testing a second sample that is independently obtained from the proband. Please note that any further analysis will result in additional costs. The classification of variants can change over the time. Please feel free to contact Genomelight in the future to determine if there have been any changes in classification of any reported variants.'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'GLsofort'
        }
      ]
    },
    {
      type: 'block-gls-info',
      children: [
        {
          type: 'p4',
          children: [
            {
              text: 'HGNC (2024/11/18)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'OMIM(2025/7/25)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'CLINVAR (2025/7/21)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'hg19 - gnomAD (v2.1)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'hg38 - gnomAD (v2.1 - liftover)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: '1000g (2015/08/26)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'EXAC (2015/11/29)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'gnomAD - MT (v3.1)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'hg19 - dbsnp (153)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'hg38 - dbsnp (156)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'CADD (v1.6)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'REVEL (v1.3)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'AlphaMissense (2023)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'SpliceAI (v1.3)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Clingen (2024/8/4)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'dbVar (2024/2/16)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'DGV (2020/2/25)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Exomiser (2023/11/4)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Refseg Gene annotation (2024/1/29)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Ensembl (2023/10/8)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Mitomap (2025/7/30)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'genomeSV (latest)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'decipher (latest)'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'block-gls-footer',
      children: [
        {
          type: 'g2',
          children: [{ text: 'Clinical Lab Director:' }]
        },
        {
          type: 'g2',
          children: [{ text: 'Date:' }]
        }
      ]
    },
    {
      type: 'block-gls-footer',
      children: [
        {
          type: 'g2',
          children: [{ text: 'physician name,PhD.,Genomelight.' }]
        },
        {
          type: 'g2',
          children: [
            { text: formatDate(report?.createdAt, 'YYYY/MM/DD') ?? '-' }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'REFERENCES'
        }
      ]
    }
  ]
}
